import React from "react";
import { Link } from "react-router-dom";
import { loginlog } from "../Constant/Index";

function Otp() {
  return (
    <>
      {/* Otp section  */}
      <section className="login_sec overflow-hidden">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="auth_form">
              {/* <div className="mobileLogo">
                <Link to="/">
                  <figure>
                    <img src={logo} alt="weblogo" className="img-fluid" />
                    dddd
                  </figure>
                </Link>
              </div> */}
              <div className="heading_wrapper">
                <div className="webLogo">
                  <Link to="/">
                    <figure>
                      <img src={loginlog} alt="weblogo" className="img-fluid" />
                    </figure>
                  </Link>
                </div>
                <p className="tagline secondary-color font-weight-bold">
                  Powerful Hand
                </p>

                <h2 className="title primary-color">Enter OTP Code</h2>
                <p className="primary-color font-weight-meduim">
                  Please enter the one-time password (OTP) sent to your email
                </p>
              </div>
              <form>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group otp-form">
                      {/* <label className="form-label">Email Address</label> */}

                      <input
                        required
                        type="text"
                        placeholder="0"
                        name="number"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group otp-form">
                      {/* <label className="form-label">Email Address</label> */}

                      <input
                        required
                        type="number"
                        placeholder="0"
                        name="number"
                        // onChange={(e) => setPassword(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group otp-form">
                      {/* <label className="form-label">Email Address</label> */}

                      <input
                        required
                        type="number"
                        placeholder="0"
                        name="number"
                        // onChange={(e) => setPassword(e.target.value)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group otp-form">
                      {/* <label className="form-label">Email Address</label> */}

                      <input
                        required
                        type="number"
                        placeholder="0"
                        name="number"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div className="button-group">

                  <Link to="/create-password"><button className="milkyBtn w-100">Submit</button></Link>
                </div>
                <div className="signup-span">
                  <p className="primary-color font-weight-semibold">
                    <span>
                      <Link to="/login">Resend Code</Link>
                    </span>
                  </p>
                </div>
              </form>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="showcase_column">
              {/* <div className="webLogo">
                <Link to="/">
                  <figure>
                    <img src={loginimg} alt="weblogo" className="img-fluid" />
                  </figure>
                </Link>
              </div> */}
            </div>
          </div>
        </div>
      </section>
      {/* ============================= */}
    </>
  );
}

export default Otp;
